export const socialLabels = { naver: '네이버' };

// 서버 응답의 socialAccounts에서 연동된 provider 목록을 꺼낸다.
export function linkedProviders(socialAccounts) {
    if (!Array.isArray(socialAccounts)) return [];
    return socialAccounts.map(account => (typeof account === 'string' ? account : account?.provider)).filter(provider => socialLabels[provider]);
}

// provider 목록을 화면 표시용 이름("네이버, 카카오")으로 바꾼다.
export function providerNames(providers) {
    return providers.map(provider => socialLabels[provider]).join(', ');
}
